import {cloneDeep} from 'lodash'
import {ModuleFc} from '@/project'
import {removeItem, updateAll, updateObject} from '@/store/utils'
import uuid from 'uuid/v1'
import footer from './modules/footer'
import header from './modules/header'
import {ErrorInfo, ErrorPayload, LayoutState, ToastInfo} from './types'
export {LayoutState}

const initState: LayoutState = {
  errorHeight: 52,
  errors: [],
  toasts: [],
  background: 'white',
  progressPercentage: 0,
  routing: false,
}

const module: ModuleFc<LayoutState> = (ctx) => {
  return {
    namespaced: true,
    state: cloneDeep(initState),
    modules: {
      footer: footer(ctx),
      header: header(ctx),
    },
    mutations: {
      removeError(status, payload: string) {
        removeItem(status.errors, {id: payload})
      },
      updateError(state, payload: ErrorPayload) {

        const {id = uuid(), autoClose = true, action = {kind: 'close'}, message} = payload
        updateAll(state.errors, [{
          message,
          autoClose,
          action,
          id,
        }])
      },
      updateErrors(state, payload: ErrorInfo[]) {
        updateAll(state.errors, payload)
      },
      updateBackground(state, background: string) {
        updateObject(state, {background}, ['background'])
      },
      initBackground(state) {
        updateObject(state, {background: initState.background})
      },
      clear(state) {
        const _initState = cloneDeep(initState)
        updateObject(state, _initState)
      },
      updateToast(state, payload: ToastInfo) {
        const {id = uuid(), message, duration = 3000} = payload
        updateAll(state.toasts, [{id, message, duration}])
      },
      removeToast(state, payload: string) {
        removeItem(state.toasts, {id: payload})
      },
      setProgress(state, payload: number) {
        state.progressPercentage = Math.min(payload, 100)
      },
      updateRouting(state, payload: boolean) {
        state.routing = payload
      }
    },
    getters: {
      errorLength(state) {
        return state.errors.length
      },
      errorSize(state) {
        const count = state.errors.length > 2 ? 2 : state.errors.length
        return state.errorHeight * count
      }
    },
  }
}

export default module
